import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PermissionService } from '../common/permission.service';
import { IOAuthService } from './iOAuthService';

 

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private permissionService: PermissionService,
        private oAuthService: IOAuthService) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        await this.oAuthService.checkAndLoadDiscoveryDocument();

        if (this.oAuthService.isAuthenticated() && localStorage.getItem('currentUser')) {
            if (route.data.permissions) {
                let currentPermmision = this.permissionService.getPermission();
                let permissionFound = currentPermmision.find(x => x.toString().toUpperCase() == route.data.permissions.toString().toUpperCase());
                if (permissionFound) {
                    return true;
                } else {
                    this.router.navigate(['/forbidden']);
                    return false;
                }
            }
            else {
                return true;
            }
        }

        this.router.navigate(['/callback']);
        return false;
    }
}
